import type { AgentTool } from '@saaga/shared/interfaces/agent-tool.interface'
import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import type { AgentNodeFormSchemaType } from './agency-node-form.schema'
import { AgentNodeIdentitySection } from './drawer-sections/agent-node-identity-section.atom'
import { AgentNodeModelSection } from './drawer-sections/agent-node-model-section.atom'
import { AgentNodePromptSection } from './drawer-sections/agent-node-prompt-section.atom'
import { AgentNodeRoleDescriptionSection } from './drawer-sections/agent-node-role-description-section.atom'
import { AgentNodeToolsSection } from './drawer-sections/agent-node-tools-section.atom'

interface AgentNodeDrawerFormProps {
  form: UseFormReturn<AgentNodeFormSchemaType>
  nodeId: string | null
  modelList: LlmModel[]
  isLoadingModels: boolean
  toolList: AgentTool[]
  isLoadingTools: boolean
  imagePreviewUrl: string | null
  onImageChange: (file: File | null) => void
  onImageRemove: () => void
}

export const AgentNodeDrawerForm = ({
  form,
  nodeId,
  modelList,
  isLoadingModels,
  toolList,
  isLoadingTools,
  imagePreviewUrl,
  onImageChange,
  onImageRemove,
}: AgentNodeDrawerFormProps): ReactNode => (
  <div className="agent-node-drawer-form space-y-6 px-6 py-4">
    <AgentNodeIdentitySection
      form={form}
      modelList={modelList}
      isLoadingModels={isLoadingModels}
      imagePreviewUrl={imagePreviewUrl}
      onImageChange={onImageChange}
      onImageRemove={onImageRemove}
    />
    <AgentNodeRoleDescriptionSection form={form} />
    <AgentNodeModelSection form={form} modelList={modelList} />
    <AgentNodePromptSection form={form} nodeId={nodeId} />
    <AgentNodeToolsSection form={form} toolList={toolList} isLoadingTools={isLoadingTools} />
  </div>
)

AgentNodeDrawerForm.displayName = 'AgentNodeDrawerForm'
